import { useState } from "react";


import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";




export const AppUpdateNotifier = () => {

    const { token, announceUpdate, isLoading } = useAuth();

    const [onAlert, setOnAlert] = useState();

    const [versionCode, setVersionCode] = useState('');




    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = isNull(versionCode);


    const handleSubmit = async () => {
        if (inputRequired) {
            handleInvalidInput();
            return;
        }
        const resp = await announceUpdate({ versionCode }, token);
        if (resp?.message) {
            setOnAlert({
                caption: "Success",
                message: resp?.message,
                close: () => {
                    setOnAlert();
                    window.location.reload();
                },
                accept: "OK",
                acceptAction: () => {
                    setOnAlert();
                    window.location.reload();
                }
            })
        } else {
            setOnAlert({
                caption: "Failed!",
                message: "Something went wrong!",
                close: () => {
                    setOnAlert();
                    window.location.reload();
                },
                accept: "OK",
                acceptAction: () => {
                    setOnAlert();
                    window.location.reload();
                }
            })
        }
    }

    const handleInvalidInput = () => {
        setOnAlert({
            caption: "Input Error!",
            message: "App version code cannot be null",
            close: () => setOnAlert(),
            accept: "Ok",
            acceptAction: () => setOnAlert()
        })
    }

    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={`Communicate app update`} />
            {(isLoading) && <Loader />}
            {onAlert &&
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    close={onAlert.close}
                    accept={onAlert.accept}
                    acceptAction={onAlert.acceptAction}
                />
            }
            <form
                className="form-container"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >

                <div className="input-container">
                    <span className="input-cap">
                        App version code
                        <span className="req-asterix">*</span>
                    </span>
                    <input
                        type="text"
                        className="input"
                        placeholder="Input the app version code"
                        value={versionCode}
                        onChange={(e) => setVersionCode(e.target.value)}
                    />
                </div>

                <button
                    className="form-button"
                >
                    Announce update
                </button>
            </form>
        </div>
    );
}